<div
  class="component-container flex flex-col h-full"
  [class.mobile]="screenType ===  'mobile'"
  [class.tablet]="screenType ===  'tablet'"
  [class.desktop]="screenType === 'desktop'"
>
  <div
    *ngIf="screenType === 'mobile'"
    class="header-section bg-digital-red flex flex-wrap w-full"
  >
    <div
      class="menu-section bg-cardinal-red w-[6rem] flex flex-col flex-wrap grow-0 content-center justify-center"
      (click)="sidenav.toggle()"
    >
      <div
        class="flex flex-wrap content-center justify-center"
      >
        <app-icon
          class="menu-icon"
          [icon]="opened ? 'close' : 'menu'"
        ></app-icon>
      </div>
      <div class="menu-label text-white font-work-sans">MENU</div>
    </div>
    <div class="logo-section text-white px-[1rem] flex flex-wrap grow content-center justify-start">
      <app-image
        class="logo mobile-logo"
        url="/assets/images/png/logo.png"
        (click)="goHome()"
      />
    </div>
    <div
      class="actions-section bg-cardinal-red w-[6rem] flex grow-0 flex-wrap flex-end content-center justify-center"></div>
  </div>
  <mat-sidenav-container
    class="content-output w-full h-full"
  >
    <mat-sidenav
      #sidenav
      [mode]="screenType === 'mobile' ? 'over' : 'side'"
      [disableClose]="screenType !== 'mobile'"
      [(opened)]="opened"
      class="sidenav-section bg-red sm:w-[20rem] md:w-[22rem] lg:w-[26rem]  border-r-[#C2C1D5] border-r-[0.1rem]"
    >
      <div
        *ngIf="screenType !==  'mobile'"
        class="header-section bg-digital-red text-white px-[2.2rem]"
      >
        <app-image
          class="logo"
          url="/assets/images/png/logo.png"
          (click)="goHome()"
        />
      </div>
      <div
        class="sidenav-outlet bg-[#F6F8FB] overflow-auto h-[calc(100%-12rem)]">
        <router-outlet name="sidenav"></router-outlet>
      </div>
      <app-side-nav-profile-menu class="absolute w-full bottom-0"></app-side-nav-profile-menu>
    </mat-sidenav>
    <mat-sidenav-content
      class="app-main-container content-section flex flex-grow h-full"
    >
      <div
        *ngIf="screenType !== 'mobile'"
        class="header-section px-[2.2rem]"
      >
        <app-breadcrumbs />
      </div>
      <div class="content-outlet">
        <router-outlet name="content"></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
